import { Component, Inject, OnInit } from "@angular/core";
import { GlobalConstants } from "../../../../common/global-constants";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { DataService } from "../../../../services/data.service";
import { AuthenticationService } from "../../../../services/authentication.service";
import { CommonUtils } from "../../../../utils/common.utils";

@Component({
  selector: "app-remove-lane-transit-time-update",
  templateUrl: "./remove-lane-transit-time-update.component.html",
  styleUrls: ["./remove-lane-transit-time-update.component.scss"],
})
export class RemoveLaneTransitTimeUpdateComponent implements OnInit {
  updateTransitTimeForm: FormGroup;
  fromCountryCodeOptions: any = [];
  transitTimeOptions: any = [];
  uploadTypeOptions: any = [];
  removeTransitTimeLanesFileTypeOptions: any = [];
  s3FilePathOptions: any[] = [];
  transitTimeConfigurationRecords: any = [];
  selectedFile: File = null;
  loading = false;
  currentWorkingRecord: any;
  currentComponentKeyPlaceholder: any = [];

  single = GlobalConstants.SINGLE_KEYWORD;
  range = GlobalConstants.RANGE_KEYWORD;
  singleTransitTimeColumns: any = [];
  rangeTransitTimeColumns: any = [];

  help_messages: any = this.dataService.help_messages;

  dropDownOptions: any = {};
  items: any = {};

  user = {};

  removeLanesFromTransitTimeFileUrl =
    GlobalConstants.REMOVE_LANES_FROM_TRANSIT_TIME_FILE_ENDPOINT;

  get progress() {
    return this.uploadFileServiceUtils.progress;
  }

  get passportEnabledShipmethods() {
    return this.dataService.passportEnabledShipmethods;
  }

  constructor(
    @Inject("RequestsService") private requestsService,
    @Inject("UploadFileServiceUtils") private uploadFileServiceUtils,
    @Inject("CommonUtils") private readonly commonUtils: CommonUtils,
    @Inject("AuthenticationService")
    private readonly authenticationService: AuthenticationService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private dataService: DataService,
    @Inject("S3Utils") private s3Utils
  ) {}

  async ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.updateTransitTimeForm = this.formBuilder.group({
      businessUseCase: ["", Validators.required],
      fromCountryCode: ["", Validators.required],
      componentKeyValue: ["", Validators.required],
      componentKeyPlaceholder: [""],
      transitTimeType: ["", Validators.required],
      uploadType: ["", Validators.required],
      removeTransitTimeLanesFileType: ["", Validators.required],
      transitTimeFile: [""],
      s3FilePath: [""],
    });

    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;
    this.items = this.commonUtils.getItemsBasedOnArc();
    this.uploadTypeOptions = this.dataService.getUploadTypeOptions;
    this.removeTransitTimeLanesFileTypeOptions =
      this.dataService.getRemoveTransitTimeLanesFileTypeOptions;
    this.s3FilePathOptions = await this.s3Utils.getAllS3FilePath(
      this.commonUtils.getBusinessBucket()
    );
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};
    this.updateTransitTimeForm
      .get(GlobalConstants.BUSINESS_USE_CASE)
      .setValue("");
    this.updateTransitTimeForm
      .get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER)
      .setValue("");
    this.singleTransitTimeColumns =
      this.rangeTransitTimeColumns =
      this.currentComponentKeyPlaceholder =
        [];
    this.dataService
      .getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode)
      .subscribe(
        (data: any[]) => {
          this.loading = false;
          this.transitTimeConfigurationRecords =
            data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
        },
        (error) => {
          this.loading = false;
          this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
        }
      );
  }

  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord =
      this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(
      this.currentWorkingRecord,
      this.transitTimeConfigurationRecords
    );

    this.updateTransitTimeForm
      .get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER)
      .setValue(
        this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]
      );
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[
      GlobalConstants.COMPONENT_KEY_PLACE_HOLDER
    ].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.updateTransitTimeForm.setControl(
      GlobalConstants.COMPONENT_KEY_VALUE,
      this.getComponentKeyValueFormGroup()
    );

    let lookUpKeyColumns = this.commonUtils.generateLookUpKeyColumns(
      this.currentWorkingRecord
    );
    this.singleTransitTimeColumns =
      lookUpKeyColumns[GlobalConstants.SINGLE_TRANSIT_TIME_COLUMNS];
    this.rangeTransitTimeColumns =
      lookUpKeyColumns[GlobalConstants.RANGE_TRANSIT_TIME_COLUMNS];

    this.updateTransitTimeForm
      .get(GlobalConstants.TRANSIT_TIME_TYPE)
      .setValue("");
    this.updateTransitTimeForm
      .get(GlobalConstants.TRANSIT_TIME_FILE)
      .setValue("");
    this.selectedFile = null;
    this.updateTransitTimeForm.get(GlobalConstants.S3_FILE_PATH).setValue("");
  }

  public onTransitTimeTypeChange(transitTimeType) {
    if (transitTimeType == GlobalConstants.CARRIER_PROVIDED_KEYWORD) {
      alert(GlobalConstants.TRANSIT_TIME_TYPE_ALERT_MESSAGE);
    }
  }

  public onTransitTimeUploadFileTypeChange() {
    if (this.getTransitTimeUploadTypeValue === GlobalConstants.UI_UPLOAD) {
      this.updateTransitTimeForm.controls.transitTimeFile.setValidators(
        Validators.required
      );
      this.updateTransitTimeForm.controls.s3FilePath.clearValidators();
    } else if (
      this.getTransitTimeUploadTypeValue === GlobalConstants.S3_UPLOAD
    ) {
      this.updateTransitTimeForm.controls.s3FilePath.setValidators(
        Validators.required
      );
      this.updateTransitTimeForm.controls.transitTimeFile.clearValidators();
    }
    this.updateTransitTimeForm.controls.transitTimeFile.updateValueAndValidity();
    this.updateTransitTimeForm.controls.s3FilePath.updateValueAndValidity();
    this.updateTransitTimeForm
      .get(GlobalConstants.TRANSIT_TIME_FILE)
      .setValue("");
    this.selectedFile = null;
    this.updateTransitTimeForm.get(GlobalConstants.S3_FILE_PATH).setValue("");
  }

  private getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl(
        "",
        Validators.required
      );
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public onFileChange(event) {
    this.selectedFile = event.target.files[0];
  }

  get getTransitTimeUploadTypeValue() {
    return this.updateTransitTimeForm.get(
      GlobalConstants.TRANSIT_TIME_UPLOAD_TYPE
    ).value;
  }

  public async submit() {
    let timestamp = Math.round(Date.now() / 1000);
    let requestConfig = JSON.parse(
      JSON.stringify(this.updateTransitTimeForm.value)
    );
    requestConfig[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestConfig[GlobalConstants.BUSINESS_UNIT] =
      this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    requestConfig[GlobalConstants.COMPONENT_KEY_VALUE] =
      this.commonUtils.buildComponentKeyValue(
        requestConfig[GlobalConstants.COMPONENT_KEY_VALUE],
        requestConfig[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]
      );

    let componentKeyValue = requestConfig[
      GlobalConstants.COMPONENT_KEY_VALUE
    ].replace(
      GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR,
      GlobalConstants.SLASH
    );
    let key =
      requestConfig[GlobalConstants.TRANSIT_TIME_TYPE] +
      GlobalConstants.SLASH +
      requestConfig[GlobalConstants.BUSINESS_UNIT] +
      GlobalConstants.SLASH +
      requestConfig[GlobalConstants.FROM_COUNTRY_CODE] +
      GlobalConstants.SLASH +
      componentKeyValue +
      GlobalConstants.SLASH +
      timestamp;
    requestConfig[GlobalConstants.KEY] = key;
    requestConfig[GlobalConstants.CREATED_BY] =
      this.user[GlobalConstants.ALIAS];
    requestConfig[GlobalConstants.LOOK_UP_KEYS] =
      this.currentWorkingRecord[GlobalConstants.LOOK_UP_KEYS];

    delete requestConfig[GlobalConstants.TRANSIT_TIME_FILE];

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(requestConfig);
      this.loading = false;
      if (hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }

    if (this.getTransitTimeUploadTypeValue === GlobalConstants.UI_UPLOAD) {
      this.uiUploadSubmit(requestConfig);
    } else if (
      this.getTransitTimeUploadTypeValue === GlobalConstants.S3_UPLOAD
    ) {
      this.S3FilePathSubmit(requestConfig, timestamp);
    }
  }

  public async uiUploadSubmit(requestBody) {
    let removeLanesBucket = this.commonUtils.getRemoveLanesBucket();
    requestBody[GlobalConstants.BUCKET] = removeLanesBucket;

    delete requestBody[GlobalConstants.S3_FILE_PATH];

    let metadata = this.commonUtils.generateMetadata(requestBody);
    // File Upload and call backend apis
    let promise = this.uploadFileServiceUtils.uploadFile(
      removeLanesBucket,
      requestBody[GlobalConstants.KEY],
      this.selectedFile,
      metadata
    );
    this.loading = true;
    await promise
      .then(() => {
        this.loading = false;
        this.toastrService.success(
          GlobalConstants.FILE_UPLOAD_SUCCESSFUL,
          GlobalConstants.TITLE_SUCCESS
        );
      })
      .catch((data) => {
        this.loading = false;
        this.toastrService.error(
          GlobalConstants.FILE_UPLOAD_FAILED,
          GlobalConstants.TITLE_ERROR
        );
      });
  }

  public S3FilePathSubmit(metadata, timestamp) {
    let uploadBucket = this.commonUtils.getUploadBucket();
    metadata[GlobalConstants.BUCKET] = uploadBucket;
    metadata[GlobalConstants.TIME_STAMP] = timestamp;
    delete metadata[GlobalConstants.CURRENT_TRANSIT_TIME];

    let requestBody = {};
    requestBody[GlobalConstants.TRANSIT_TIME_BUSINESS_BUCKET] =
      this.commonUtils.getBusinessBucket();
    requestBody[GlobalConstants.TRANSIT_TIME_BUSINESS_FILE_KEY] =
      this.updateTransitTimeForm.get(GlobalConstants.S3_FILE_PATH).value;
    requestBody[GlobalConstants.TRANSIT_TIME_UPLOAD_BUCKET] = uploadBucket;
    requestBody[GlobalConstants.TRANSIT_TIME_UPLOAD_FILE_KEY] =
      metadata[GlobalConstants.KEY];
    requestBody[GlobalConstants.METADATA] = JSON.stringify(metadata);

    // Call backend apis
    this.loading = true;
    this.requestsService
      .put(this.removeLanesFromTransitTimeFileUrl, requestBody)
      .subscribe(
        () => {
          this.loading = false;
          this.toastrService.success(
            GlobalConstants.REQUEST_SUCCESSFUL,
            GlobalConstants.TITLE_SUCCESS
          );
        },
        (error) => {
          this.loading = false;
          this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
        }
      );
  }
}
